import { StyledButtonContainer, StyledLoader, StyledLoaderContainer } from './styled';

export const LoadingButton = ({
  name,
  loading = 0,
  width = '180px',
  height = '40px',
  fs = '16px',
}) => (
  <StyledButtonContainer width={width} height={height}>
    <StyledLoaderContainer fs={fs}>
      {loading ? <StyledLoader/> : name}
    </StyledLoaderContainer>  
  </StyledButtonContainer>
);
